import React, { ReactNode } from 'react';
import CardContainer from '../CardContainer';
import Title from '../Title';
import Text from '../Text';
import withSkeleton from '../../hoc/withSkeleton';
import ParagraphWithHeadingSkeleton from './ParagraphWithHeadingSkeleton';
import Wrapper from '../Wrapper';
import './ParagraphWithHeading.less';

export type ParagraphWithHeadingProps = {
  title: ReactNode;
  paragraph?: string;
  fallBack?: string;
  isHtml?: boolean;
  breakWord?: boolean;
  titleSize?: 1 | 2 | 3 | 4;
  paragraphize?: 1 | 2 | 3 | 4;
  titleMargin?: 1 | 2 | 3 | 4;
};

const ParagraphWithHeading: React.FC<ParagraphWithHeadingProps> = ({
  title,
  paragraph,
  fallBack = 'No Data',
  isHtml = false,
  breakWord = false,
  titleSize = 1,
  paragraphize = 2,
  titleMargin = 4,
}) => {
  return (
    <CardContainer>
      <Wrapper mb={titleMargin}>
        <Text semiBold level={titleSize}>
          {title}
        </Text>
      </Wrapper>
      {!!paragraph && !isHtml && <Text level={paragraphize}>{paragraph}</Text>}
      {!!paragraph && isHtml && (
        <Text
          level={paragraphize}
          innerText={paragraph}
          breakWord={breakWord}
        />
      )}
      {!paragraph && (
        <Text textColor="dark-50" level={2}>
          {fallBack}
        </Text>
      )}
    </CardContainer>
  );
};

export default withSkeleton(ParagraphWithHeading, ParagraphWithHeadingSkeleton);
